
import HTTPService              from "@/js/Shared/Services/HTTP/HTTPService";
import HTTPResponseEntity       from "@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity";
import SAPOMailConfig           from "@/SAPOMailConfig";

export { FoldersHTTPServiceSingleton as default };

/**
* Folders HTTP Service
*
* Handles all folders api comunnications
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FoldersHTTPService {
  /**
   * HTTP Endpoints
   *
   * @private
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  endpoints = SAPOMailConfig.client.endpoints;

  /**
   * Returns main folders index entity, sub folders and main folders in the same index
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
   async fetchMain() {
    return await HTTPService.oldPost(this.endpoints.imp_services + '/responsiveInit', {}, 'folders_fetch_main');
  }

  /**
   * Fetches all folders from the server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<HTTPResponseEntity>}
   */
  async fetchAll() {
    let data = {
      all : 1,
    }

    return await HTTPService.oldPost(this.endpoints.imp_services + '/listmailboxesApi', data, 'folders_fetch_all');
  }

  /**
   * Creates a new folder
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String}            folder_name   new folder name
   * @param {FolderEntity|null} parent_folder parent folder
   *
   * @return {Promise<HTTPResponseEntity>}
   */
  async create(folder_name, parent_folder) {
    let parent_id = (parent_folder) ? parent_folder.id : null;

    let data  = {
      mbox : folder_name,
    };

    if (parent_id) {
      data.parent = parent_id;
    }

    return await HTTPService.oldPost(this.endpoints.imp_services + '/createMailbox', data);
  }

  /**
   * Polls a folder
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} folder_id folder id
   *
   * @return {Promise<HTTPResponseEntity>}
   */
    async poll(folder_id) {
      let data  = {
        poll : `"${folder_id}"`,
      };

      return await HTTPService.oldPost(this.endpoints.imp_services + '/poll', data);
    }

  /**
   * Edits a folder name
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} folder_id folder id
   * @param {String} new_name  folder new name
   *
   * @return {Promise<HTTPResponseEntity>}
   */
  async edit(folder_id, new_name) {
    let data  = {
      new_name : new_name,
      old_name : folder_id,
    };

    return await HTTPService.oldPost(this.endpoints.imp_services + '/renameMailbox', data);
  }

  /**
   * Moves a folder
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String|null} target_folder_id new parent folder id, or null for root folder
   * @param {String}      source_folder    old parent folder id
   * @param {String}      new_name         folder new name
   *
   * @return {Promise<HTTPResponseEntity>}
   */
   async move(target_folder_id, source_folder, new_name) {
      let data  = {
        new_name   : new_name,
        old_name   : source_folder,
        new_parent : target_folder_id,
      };

      return await HTTPService.oldPost(this.endpoints.imp_services + '/renameMailbox', data);
    }

  /**
   * Edits a folder name
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} folder_id        folder id
   * @param {Number} last_message_id last message id to delete, deletes all messages id up to this id
   *
   * @return {Promise<HTTPResponseEntity>}
   */
   async empty(folder_id, last_message_id) {
    let data  = {
      lastBUID : last_message_id,
      mbox     : folder_id,
    };

    return await HTTPService.oldPost(this.endpoints.imp_services + '/emptyMailbox', data, 'folders_empty_' + folder_id);
  }

  /**
   * Deletes a folder and all it's childs
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} folder_id folder id
   *
   * @return {Promise<HTTPResponseEntity>}
   */
   async delete(folder_id) {
    let data  = {
      mbox       : folder_id,
      container  : 0,
      subfolders : 'on',
    };

    return await HTTPService.oldPost(
      this.endpoints.imp_services + '/deleteMailbox', data, 'folders_delete_' + folder_id
    );
  }
}

/**
* @param {FoldersHTTPService}
*/
const FoldersHTTPServiceSingleton = new FoldersHTTPService();